import { Component, effect, inject } from '@angular/core';
import { RouterLink, RouterOutlet, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';

import { AuthService } from './services/auth.service';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { KeycloakService } from './services/keycloak.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    CommonModule,
    CapitalizePipe,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  username?: string | undefined;
  userTitle?: string | undefined;
  isSidebarCollapsed = false;

  kc = inject(KeycloakService);

  tokenParsed: any = this.kc.getParsedToken();
  roles: string[] = this.tokenParsed?.realm_access?.roles ?? [];

  ngOnInit() {
    console.log('Current Environment:', environment.name);
    console.log('Production mode:', environment.production);
    console.log('API URL:', environment.apiUrl);
    this.username = this.kc.username ?? 'Guest';
    if (this.roles.includes('SM_USER')) this.userTitle = 'user';
    if (this.roles.includes('SM_SUPERVISOR')) this.userTitle = 'supervisor';
  }

  logout() {
    return this.kc.logout();
  }

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
}
